<template>
  <div v-if="this._type == 0">
    <Row>
      <Col offset="1" span="21">
        <Row type="flex" align="middle" justify="center">
          <Col v-for="row in columns" :key="row.title">
            <Tooltip transfer placement="right" :content="row.title" :delay="500">
              <Button class="demo" :style="{color:row.color}" @click="myclick">
                  {{row.data}}
                </Button>
            </Tooltip>
          </Col>
        </Row>
      </Col>
      <Col span="2">
          <Tooltip transfer placement="right" :content="dingding_text" :delay="300">
            <Button class="demo" :loading="loading_status" :icon="dingding_icon" :style="dingding_style()" @click="myclick"/>
          </Tooltip>
      </Col>
    </Row>
  </div>
  <!-- 显示币安大数据 -->
  <div v-else-if="this._type == 1">
    <Tooltip transfer placement="left" style="white-space:normal" :delay="300">
        <Button :style="binance_data_style" type="text" >{{ binance_data_text }}</Button>
        <div v-for="(item, index) of set_binance_data()" :key="index" slot="content">
          <span> {{ item }} </span>
        </div>
    </Tooltip>
  </div>
  <div v-else>
    </div>
</template>
<script>
export default {
  name: "render_table_view",
  data() {
    return {
      loading_status:false,
      binance_data_text:"",
      binance_data_style:{
        'box-shadow':'none',
        "color":this.dingding_color,
        'font-size':'12px'
      }
    }
  },
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    dingding_text: {
      type: String,
      default:""
    },
    dingding_color: {
      type: String,
      default:"black"
    },
    dingding_icon:{
      type: String,
      default:""
    },
    _type:{
      type: Number,
      default:0
    },
    binance_data:{
      type: String,
      default:""
    }
  },
  methods:{
    myclick() {
      this.$emit("myclick", 1);
    },
    dingding_style() {
      return {
        "font-size":"20px",
        "color":this.dingding_color
      }
    },
    // 处理币安数据，以Tooltip展示在前端上
    set_binance_data() {
      // __binance_big_data__[self.set_symbol]["8_hour_rate"],
      // __binance_big_data__[self.set_symbol]["sum_open_interest"],
      // __binance_big_data__[self.set_symbol]["sum_open_interest_value"],
      // __binance_big_data__[self.set_symbol]["ls_ratio_count"],
      var res = []
      var data = this.binance_data.split("|")
      this.binance_data_text = data[0]
      for (var i in data) {
        res.push( data[i] )
      }
      res.shift()
      res[0] = "合约持仓量:    " + res[0] + " 张"
      res[1] = "合约持仓价值:    " + res[1] + " USD"
      res[2] = "多空比:    " + res[2]
      return res
    }
  },
  watch: {
    dingding_icon() {
      this.loading_status = true
      setTimeout(() => {
        this.loading_status = false
      }, 300)
    }
  }
};
</script>
<style>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
</style>
